import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router'
import './stile.css'
// Dopo stile.css e non con @import al suo interno: le regole del telefono devono prevalere su
// quelle generali a parita' di specificita' (stile-telefono.css).
import './stile-telefono.css'
import { FornitoreSessione, useSessione } from './servizi/sessione.tsx'
import { Impalcatura } from './componenti/Impalcatura.tsx'
import { Attesa } from './componenti/Pezzi.tsx'
import { SbloccoTelefono } from './componenti/SbloccoTelefono.tsx'
import { RestaConnesso } from './componenti/RestaConnesso.tsx'
import { RicordaComputer } from './componenti/RicordaComputer.tsx'
import { Accesso } from './pagine/Accesso.tsx'
import { Ingresso, ePercorsoDiIngresso } from './pagine/Ingresso.tsx'
import { CambioPassword } from './pagine/CambioPassword.tsx'
import { SecondoFattore, SecondoFattoreObbligatorio } from './pagine/SecondoFattore.tsx'
import { Profilo } from './pagine/Profilo.tsx'
import { Cruscotto } from './pagine/Cruscotto.tsx'
import { Persone } from './pagine/Persone.tsx'
import { DaCompletare } from './pagine/DaCompletare.tsx'
import { Scheda } from './pagine/Scheda.tsx'
import { NuovaPersona } from './pagine/NuovaPersona.tsx'
import { StampaScheda } from './pagine/StampaScheda.tsx'
import { StampaModuloProgetto } from './pagine/StampaModuloProgetto.tsx'
import { RegistraIntervento } from './pagine/RegistraIntervento.tsx'
import { Report } from './pagine/Report.tsx'
import { Posta } from './pagine/Posta.tsx'
import { FinestraPosta } from './pagine/posta/FinestraPosta.tsx'
import { Registrazioni } from './pagine/Registrazioni.tsx'
import { Amministrazione } from './pagine/Amministrazione.tsx'
import { Approvazioni } from './pagine/Approvazioni.tsx'
import { AttivitaCollettive } from './pagine/AttivitaCollettive.tsx'
import { Messenger, RitornoAlMessenger } from './pagine/Messaggi.tsx'
import { Migrazione } from './pagine/Migrazione.tsx'
import { Interventi } from './pagine/elenchi/Interventi.tsx'
import { Mediatori } from './pagine/elenchi/Mediatori.tsx'
import { LeMieMediazioni } from './pagine/mediazioni/LeMieMediazioni.tsx'
import { Mediazione } from './pagine/mediazioni/Mediazione.tsx'
import { CalendarioMediazioni } from './pagine/mediazioni/CalendarioMediazioni.tsx'
import { IlMioCalendario } from './pagine/mediazioni/IlMioCalendario.tsx'
import { Agenda } from './pagine/agenda/Agenda.tsx'
import { FollowUp } from './pagine/elenchi/FollowUp.tsx'
import { Notifiche } from './pagine/elenchi/Notifiche.tsx'
import { Audit } from './pagine/elenchi/Audit.tsx'
import { Enti } from './pagine/Enti.tsx'
import { Ente } from './pagine/Ente.tsx'
import { CatalogoFondi, Progetti } from './pagine/Progetti.tsx'
import { Progetto } from './pagine/Progetto.tsx'
import { Registro, ServizioErogato } from './pagine/Registro.tsx'
import { Sede, Sedi } from './pagine/Sedi.tsx'
import { CataloghiBancari } from './pagine/CataloghiBancari.tsx'
import { Decisioni } from './pagine/Decisioni.tsx'
import { RegistroEmail } from './pagine/RegistroEmail.tsx'
import { Esportazioni } from './pagine/Esportazioni.tsx'
import { CapitoloGuida, Guida } from './pagine/guida/Guida.tsx'
import { Novita } from './pagine/guida/Novita.tsx'
import { Formazione } from './pagine/Formazione.tsx'

function Rotte() {
  const { io, caricamento, bloccato, propostaFaceId, propostaComputer } = useSessione()
  // Web app dell'iPhone ricordata (521): Face ID prima di tutto, anche sopra una pagina gia' aperta.
  if (bloccato) return <SbloccoTelefono />
  if (caricamento) return <div className="accesso"><Attesa /></div>
  // Senza secondo fattore superato l'applicazione non si apre, nemmeno dopo un ricaricamento:
  // /auth/io risponde anche a meta' autenticazione, quindi il controllo va fatto qui.
  // Invito, password nuova e collegamento si aprono senza sessione: sono le pagine dove portano
  // le email. Tutti gli altri indirizzi, senza sessione, mostrano l'accesso.
  if (!io) return ePercorsoDiIngresso(window.location.pathname) ? <Ingresso /> : <Accesso />
  if (io.mfaAttiva && !io.mfaVerificata) return <Accesso secondoFattore />
  // Password provvisoria: non si va oltre finche' non se ne sceglie una propria. Il
  // controllo sta qui e non in una rotta, cosi' non lo si aggira scrivendo un indirizzo.
  if (io.deveCambiarePassword) return <CambioPassword />
  // Secondo fattore obbligatorio per gli incarichi e non ancora attivo (493): come per la password
  // provvisoria, si va dritti alla configurazione. L'API rifiuta comunque tutto il resto.
  if (io.secondoFattore?.daAttivareOra) return <SecondoFattoreObbligatorio />

  return (
    <>
    {propostaFaceId && <RestaConnesso />}
    {propostaComputer && <RicordaComputer />}
    <Routes>
      {/* Ritorno al servizio di accesso del messenger (479): fuori dall'impalcatura, dura un istante. */}
      <Route path="messenger/accesso" element={<RitornoAlMessenger />} />
      {/* La webmail in una finestra a parte (4/11/2026): senza menu e testata, dopo gli stessi controlli. */}
      <Route path="posta/finestra" element={<FinestraPosta />} />
      <Route element={<Impalcatura />}>
        <Route index element={<Cruscotto />} />
        <Route path="persone" element={<Persone />} />
        <Route path="da-completare" element={<DaCompletare />} />
        <Route path="persone/nuova" element={<NuovaPersona />} />
        <Route path="persone/:id" element={<Scheda />} />
        <Route path="persone/:id/stampa" element={<StampaScheda />} />
        <Route path="persone/:id/moduli-progetto/:progetto" element={<StampaModuloProgetto />} />
        <Route path="persone/:id/moduli-progetto/:progetto/due-moduli" element={<StampaModuloProgetto key="due-moduli" dueModuli />} />
        <Route path="persone/:id/intervento" element={<RegistraIntervento />} />
        <Route path="persone/:id/intervento/:interventoId" element={<RegistraIntervento />} />
        <Route path="interventi" element={<Interventi />} />
        <Route path="follow-up" element={<FollowUp />} />
        <Route path="attivita" element={<AttivitaCollettive />} />
        <Route path="enti" element={<Enti />} />
        <Route path="enti/:id" element={<Ente />} />
        <Route path="sedi" element={<Sedi />} />
        <Route path="sedi/:id" element={<Sede />} />
        <Route path="registro" element={<Registro />} />
        <Route path="registro/:id" element={<ServizioErogato />} />
        <Route path="mediatori" element={<Mediatori />} />
        <Route path="mediazioni" element={<LeMieMediazioni />} />
        {/* Calendario delle mediazioni e «Il mio calendario» del mediatore (557). */}
        <Route path="mediazioni/calendario" element={<CalendarioMediazioni />} />
        <Route path="mediazioni/mio-calendario" element={<IlMioCalendario />} />
        {/* Agenda della sede e «La mia agenda» (559-560). */}
        <Route path="agenda" element={<Agenda />} />
        <Route path="mediazioni/:id" element={<Mediazione />} />
        <Route path="progetti" element={<Progetti />} />
        <Route path="progetti/:id" element={<Progetto />} />
        <Route path="fondi" element={<CatalogoFondi />} />
        <Route path="cataloghi-bancari" element={<CataloghiBancari />} />
        <Route path="messaggi" element={<Messenger />} />
        <Route path="notifiche" element={<Notifiche />} />
        <Route path="report" element={<Report />} />
        <Route path="esportazioni" element={<Esportazioni />} />
        <Route path="posta" element={<Posta />} />
        <Route path="audit" element={<Audit />} />
        <Route path="approvazioni" element={<Approvazioni />} />
        <Route path="decisioni" element={<Decisioni />} />
        <Route path="registrazioni" element={<Registrazioni />} />
        <Route path="migrazione" element={<Migrazione />} />
        <Route path="amministrazione" element={<Amministrazione />} />
        <Route path="amministrazione/email" element={<RegistroEmail />} />
        {/* Guida illustrata e Novità (31/10/2026): per tutti, i capitoli secondo gli incarichi. */}
        <Route path="guida" element={<Guida />} />
        <Route path="guida/:capitolo" element={<CapitoloGuida />} />
        <Route path="novita" element={<Novita />} />
        <Route path="formazione" element={<Formazione />} />
        {/* Il proprio secondo fattore (493): attivazione, codici di recupero, sostituzione dell'app. */}
        <Route path="secondo-fattore" element={<SecondoFattore />} />
        <Route path="profilo" element={<Profilo />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
    </>
  )
}

createRoot(document.getElementById('radice')!).render(
  <StrictMode>
    <BrowserRouter>
      <FornitoreSessione>
        <Rotte />
      </FornitoreSessione>
    </BrowserRouter>
  </StrictMode>,
)
